// =============================
// Email: info@xx.com
// www.xx.com/templates
// =============================

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';

import { LocalStoreManager } from './local-store-manager.service';
import { ConfigurationService } from './configuration.service';
import { DBkeys } from './db-keys';
import { LoginResponse } from '../models/login-response.model';

@Injectable()
export class OidcHelperService {

  private readonly clientId = 'quickapp_spa';
  private readonly scope = 'openid email phone profile offline_access roles quickapp_api';

  private get tokenEndpoint() { return this.configurations.authServerUrl + '/connect/token'; }

  constructor(
    private http: HttpClient,
    private oauthService: OAuthService,
    private configurations: ConfigurationService,
    private localStorage: LocalStoreManager) {

  }


  loginWithPassword(userName: string, password: string) {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('username', userName)
      .append('password', password)
      .append('client_id', this.clientId)
      .append('grant_type', 'password')
      .append('scope', this.scope);

    return this.http.post<LoginResponse>(this.tokenEndpoint, params, { headers: header, withCredentials: true });
  }


  verifyMfa(mfaToken: string, code: string, rememberdevice: boolean) {

    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    const params = new HttpParams()
      .append('grant_type', 'mfa')
      .append('mfa_token', mfaToken)
      .append('otp', code)
      .append('scope', this.scope)
      .append('rememberdevice', rememberdevice ? 'true' : 'false')
      .append('client_id', this.clientId);

    return this.http.post<LoginResponse>(this.tokenEndpoint, params, { headers: header, withCredentials: true });
  }

  refreshLogin() {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('refresh_token', this.refreshToken)
      .append('client_id', this.clientId)
      .append('grant_type', 'refresh_token');

    return this.http.post<LoginResponse>(this.tokenEndpoint, params, { headers: header });
  }

  // Admin proxy login: exchange the admin's access token for a token whose subject is the
  // target user. All authorization/guardrails are enforced server-side by the grant.
  impersonate(targetUserId: string, adminToken: string) {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('grant_type', 'impersonation')
      .append('admin_token', adminToken)
      .append('target_user_id', targetUserId)
      .append('scope', this.scope)
      .append('client_id', this.clientId);

    return this.http.post<LoginResponse>(this.tokenEndpoint, params, { headers: header, withCredentials: true });
  }

  get accessToken(): string {
    return this.localStorage.getData(DBkeys.ACCESS_TOKEN);
  }

  get accessTokenExpiryDate(): Date {
    return this.localStorage.getDataObject<Date>(DBkeys.TOKEN_EXPIRES_IN, true);
  }

  get refreshToken(): string {
    return this.localStorage.getData(DBkeys.REFRESH_TOKEN);
  }

  get isSessionExpired(): boolean {
    if (this.accessTokenExpiryDate == null) {
      return true;
    }

    return this.accessTokenExpiryDate.valueOf() <= new Date().valueOf();
  }
}
